import { Icon } from '../../UI';

export const SimpleDropdownItem = ({
  selected,
  title,
  onClick,
}: {
  selected: string;
  title: string;
  onClick(param: string): void;
}) => {
  const isSelected = selected === title;

  return (
    <div
      className="flex items-center justify-between w-full gap-14"
      onClick={() => {
        !isSelected && onClick(title);
      }}
    >
      {title}
      {isSelected && <Icon svgName="mark" />}
    </div>
  );
};
